<template>
  <div>
    <div class="loading" v-if="fetchData">
      <load-data></load-data>
    </div>
    <div class="coursesOptions" v-else>
      <b-row>
        <b-col md="12">
          <b-card>
            <div class="courseDetails d-flex justify-content-between flex-wrap">
              <div class="name d-flex">
                <h6 class="text-dark">Name:</h6>
                <h6 class="text-info ml-2">
                  {{ courseInfo.name }} ({{ courseInfo.code }})
                </h6>
              </div>

              <div class="subgroup d-flex">
                <h6 class="text-dark">
                  {{
                  getCustomNames.userSubgroup.custom_name != null
                  ? getCustomNames.userSubgroup.custom_name
                  : "Usersubgroup"
                  }}
                  Code -
                  {{
                  getCustomNames.userGroup.custom_name != null
                  ? getCustomNames.userGroup.custom_name
                  : "Usergroup"
                  }}
                  Code :
                </h6>
                <h6 class="text-info ml-2">
                  {{ courseInfo.usersubgroup.code }} -
                  {{ courseInfo.usersubgroup.usergroup.code }}
                </h6>
              </div>
              <div class="code d-flex">
                <h6 class="text-dark">Academic Year:</h6>
                <h6 class="text-info ml-2">{{ courseInfo.academic_year }}</h6>
              </div>
            </div>
          </b-card>
          <br />
        </b-col>

        <b-col md="2" v-if="isStudent">
          <b-list-group>
            <b-list-group-item :active="currentOption == optionIndex ? true : false"
              v-for="(option, optionIndex) in coursesOptions" :key="optionIndex"
              @click="switchCourseComponent(option.component, optionIndex)">
              {{ option.text }}
            </b-list-group-item>
          </b-list-group>
        </b-col>
        <b-col md="2" class="sidebar-scroll" v-else>
          <b-list-group>
            <fieldset v-for="(group, groupIndex) in coursesOptions" :key="groupIndex" :class="{ 'custom-fieldset': group.items.length > 1 || group.fieldset }">
              <legend>{{ group.group }}</legend>
              <div v-for="(option, optionIndex) in group.items" :key="optionIndex">
                <div v-if="!option.hasChild">
                  <b-list-group-item :active="currentOption == optionIndex && currentGroup == groupIndex ? true : false"
                    @click="switchCourseComponent(option.component, optionIndex, groupIndex)">
                    {{ option.text }}
                  </b-list-group-item>
                </div>
                <div v-else>
                  <b-list-group-item @click="toggleMenu" class="d-flex justify-content-between align-items-center">
                    {{ option.text }} <b-icon :icon="isOpen ? 'chevron-up' : 'chevron-down'"></b-icon>
                  </b-list-group-item>
                  <div class="nested-wrapper" v-if="isOpen">
                      <ul class="nested-list">
                        <li v-for="(child,childIndex) in option.children" :key="childIndex"
                        :class="{'submenu-active': currentchild == childIndex}"
                        @click="switchCourseComponent(child.component, optionIndex, groupIndex, childIndex)">
                          {{child.name}}
                        </li>
                      </ul>
                    </div>
                </div>
              </div>
            </fieldset>
          </b-list-group>
        </b-col>
        <b-col md="10" class="pl-5">
          <component v-bind:is="currentComponent" :courseInfo="course"
            :course_id="course_id" :courseId="courseId" :role_by="courseInfo.roleBy" :roles="courseInfo.roles || [courseInfo.roleBy]"
            :courseInstructor="courseInstructor" :usergroupId="usergroupId" :editCourseComponents="editCourseComponents"
            @CourseUpdated="getAdditionalCourseInfo()"></component>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import LessonPlanListing from "./lesson_plan/LessonPlanListing.vue";
import CourseResourcelink from "./course_resourcelink/resourcelinks.vue";
import Outcome from "./program_outcome/Outcome.vue";
import Module from "./module/Module.vue";
import CoPoPsoTimetable from "./copopsomapping/CoPoPsoTimetable.vue";
import ProgrammeOutcome from '@/components/usergroupProgrammeOutcome/UsergroupPoGroup.vue'
import ProgrammeSpecificOutcome from '@/components/usergroupPso/UsergroupPsoGroup.vue'
import UniversityExamConfig from "../university_exam/UniversityExamConfig.vue";
import TextBookReferesnces from "./TextBookReferesnces.vue";
import AdditionalInfo from "./AdditionalInfo";
import StudentsGrouping from "./students_grouping/studentsgrouping.vue";
import AttendancetypeLimit from "./attendancetypeLimit.vue";
import LabDashboard from "../../../courseLab/LabDashboard.vue";
import SeminarDashboard from "../../../courseSeminar/SeminarDashboard.vue";
import SeminarDashboardNew from "../../../courseSeminar/SeminarDashboardNew.vue";
import ClassParticipants from "./ClassParticipants.vue";
import ProjectDashboard from "../../../courseProject/ProjectDashboard.vue";
import ProjectDashboardNew from "../../../courseProject/ProjectDashboardNew.vue";
TextBookReferesnces;
import ExperimentEvaluationParameters from "../../../courseLab/ExperimentEvaluationParameters.vue";
import LaboratoryContinuousEvaluation from "../../../courseLab/LaboratoryContinuousEvaluation.vue";
import LaboratoryInternalExam from "../../../courseLab/LaboratoryInternalExam.vue";
import AdditionalEvaluation from "../../../courseLab/AdditionalEvaluation.vue";
import Moderations from "./Moderations.vue";

export default {
  props: [
    "courseInfo",
    "course_id",
    "courseId",
    "courseInstructor",
    "usergroupId",
    "editCourseComponents",
    "studentTab",
    "course_type",
  ],
  async created() {
    this.fetchData = true;
    this.isStudent = this.$store.getters.defaultInstitute.userRole == "Student";

    if (this.isStudent) {
      this.coursesOptions = [
        { text: "Text Book & References", component: "TextBookReferesnces" },
        { text: "Course Outcome", component: "Outcome" },
        { text: "Course Syllabus", component: "Module" },
        { text: "Additional Info", component: "AdditionalInfo" },
        { text: "Resource & Links", component: "CourseResourcelink" },
      ];
      this.currentComponent = TextBookReferesnces;
    } 
    else if (this.courseInfo.roleBy === "projectFaculty" || this.courseInfo.roleBy === "seminarFaculty") {
      const roles = this.courseInfo.roles || [this.courseInfo.roleBy];
      const items = [];
      if (roles.includes('projectFaculty')) {
        items.push({ text: "Project With CO-Mapping", component: "ProjectDashboardNew" });
      }
      if (roles.includes('seminarFaculty')) {
        items.push({ text: "Seminar With CO-Mapping", component: "SeminarDashboardNew" });
      }
      this.coursesOptions = [{ group: "", items }];
      this.currentComponent = items[0].component;
    } else {
      this.coursesOptions = [
        {
          group: "",
          items: [
            { text: "Students Grouping", component: "StudentsGrouping" },
          ]
        },
        {
          group: "Outcome & Mapping",
          items: [
            { text: "Programme Outcome", component: "ProgrammeOutcome" },
            { text: "Programme Specific Outcome", component: "ProgrammeSpecificOutcome" },
            { text: "Course Outcome", component: "Outcome" },
            { text: "CO-PO/PSO Mapping", component: "CoPoPsoTimetable" }
          ]
        },
        {
          group: "Course Basic Info",
          items: [
            { text: "Course Syllabus", component: "Module" },
            { text: "Lesson Plans", component: "LessonPlanListing" },
            { text: "Text Book & References", component: "TextBookReferesnces" },
            { text: "Additional Info", component: "AdditionalInfo" },
            { text: "Resource & Links", component: "CourseResourcelink" }
          ]
        },
        {
          group: "Laboratory / Project / Seminar",
          items: [
            { text: "Laboratory", component: "LabDashboard", hasChild: true, children: this.labSettingTabs },
            { text: "Project with CO-Mappings", component: "ProjectDashboardNew" },
            { text: "Seminar with CO-Mapping", component: "SeminarDashboardNew" }
          ]
        },
        {
          group: "Evaluation & Participation",
          items: [
            { text: "Class Participation", component: "ClassParticipants" },
            { text: "Moderation", component: "Moderations" },
            { text: "University Exam", component: "UniversityExamConfig" },
          ]
        },
        {
          group: "Student Leave Limit",
          fieldset: true,
          items: [
            { text: "Students Attendance Limits", component: "AttendancetypeLimit" },
          ]
        },
        {
          group: "Obsolete",
          items: [
            { text: "Project", component: "ProjectDashboard" },
            { text: "Seminar", component: "SeminarDashboard" }
          ]
        }
      ];
      this.currentComponent = StudentsGrouping;
    }
    await this.getAdditionalCourseInfo();
    this.fetchData = false;
  },

  components: {
    LessonPlanListing,
    Outcome,
    Module,
    ProgrammeOutcome,
    ProgrammeSpecificOutcome,
    CoPoPsoTimetable,
    UniversityExamConfig,
    TextBookReferesnces,
    AdditionalInfo,
    CourseResourcelink,
    StudentsGrouping,
    AttendancetypeLimit,
    LabDashboard,
    SeminarDashboard,
    SeminarDashboardNew,
    ProjectDashboard,
    ProjectDashboardNew,
    ClassParticipants,
    ExperimentEvaluationParameters,
    LaboratoryContinuousEvaluation,
    LaboratoryInternalExam,
    AdditionalEvaluation, 
    Moderations
  },
  data() {
    return {
      fetchData: false,
      currentOption: 0,
      currentGroup: 0,
      currentComponent: "",
      course: {},
      coursesOptions: [],
      isOpen: false,
      isStudent: null,
      labSettingTabs: [
        {
          name: "Experiment & Evaluation Parameters",
          component: "ExperimentEvaluationParameters",
        },
        {
          name: "Laboratory Continuous Evaluation",
          component: "LaboratoryContinuousEvaluation",
        },
        {
          name: "Laboratory Internal Exam",
          component: "LaboratoryInternalExam",
        },
        {
          name: "Additional Evaluation Components",              
          component: "AdditionalEvaluation",
        },
      ],
    };
  },
  computed: {
    getCustomNames() {
      return this.$store.getters.getCustomNamings;
    },
  },
  methods: {
    toggleMenu(){
      this.isOpen = !this.isOpen;
    },
    async getAdditionalCourseInfo() {
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/courses/${this.courseInfo.id}?course_property=1`;
      await this.$axios.get(url).then((res) => {
        this.course = res.data;
      });
    },
    switchCourseComponent(selectedComponent, optionIndex, groupIndex, childIndex = null) {
      this.currentComponent = selectedComponent;
      this.currentOption = optionIndex;
      this.currentGroup = groupIndex;
      this.currentchild = childIndex;
    },
  },
};
</script>

<style >
.coursesOptions .list-group .list-group-item {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 10px;
  cursor: pointer;
  background-color: #007bff;
  color: #ffffff;
  border-radius: 10px;
}

.coursesOptions .list-group .list-group-item.active {
  color: #007bff;
  background-color: #ffffff;
}

.sidebar-scroll {
  height: calc(100vh - 20vh);          /* full screen height */
  overflow-y: auto;       /* enable vertical scroll */
  overflow-x: hidden;
}
.sidebar-scroll::-webkit-scrollbar {
  width: 8px;
}

.sidebar-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.sidebar-scroll::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  transition: 0.3s;
}

.sidebar-scroll::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.45);
}

.custom-fieldset {
  border: 1px solid #aaa;
  padding: 10px;
}

.custom-fieldset legend {
  width: auto;
  padding: 0 10px;
  font-size: 14px;
  font-weight: 600;
}

.nested-wrapper {
  background-color: #f8f9fa;
  padding: 5px 0;
}

.nested-list {
  list-style: none;
  padding-left: 0;
  margin: 0;
}

.nested-list li {
  padding: 8px 10px;
  font-size: 14px;
  cursor: pointer;
  border-radius: 4px;
  transition: background 0.2s ease;
}

.nested-list li:hover {
  background-color: #007bff;
  color: #fff;
}

.submenu-active {
  background-color: #007bff;
  color: #fff;
}

.rotate {
  transform: rotate(90deg);
  transition: 0.3s ease;
}

</style>
